export const readerDocsData = [
  {
    slug: "101-welcome-outline",
    title: "Welcome Outline ",  
    miniTitles: [
      { title: "Introduction", page: 0 }, 
      { title: "Chart Patterns", page: 1 },
      { title: "Japanese Candlestick Patterns", page: 2 },
      { title: "Fibonacci Trading", page: 3 },
    ],
    level: 100,
    subject: "Welcome Outline", // optional: could be used for sidebar grouping
  },
  {
    slug: "Advanced-Technical-Analysis",
    title: "Advanced Technical Analsis ",
    miniTitles: [
      { title: "Introduction", page: 1 },
      { title: "Chart Patterns", page: 2 },
      { title: "Japanese Candlestick Patterns", page: 9},
      { title: "Fibonacci Trading", page: 23}
    ],
    level: 700,
    subject: "Advanced Technical Analysis",
  },
  // ... more docs
];
